export class DynamicI18nHandler {
  private baseMessages: Record<string, any> = {}
  private baseLocalText: Record<string, any> = {}
  private serverConfigMap: Map<string, string> = new Map()
  public processedMessages: Record<string, any> = {}

  /**
   * 初始化基础国际化资源
   */
  initBaseMessages(messages: Record<string, any>): void {
    this.baseMessages = { ...messages }
    this.processedMessages = { ...messages }
  }

  /**
   * 初始化基础语言文本
   */
  initBaseLocalText(localText: Record<string, any>): void {
    this.baseLocalText = { ...localText }
    this.processedMessages = { ...localText }
  }

  /**
   * 更新服务端配置
   */
  updateServerConfig(configList: Array<{ placeholder: string; replaceText: string }>): void {
    // 清空旧配置
    this.serverConfigMap.clear()
    //console.log("3. 获取到configList",configList)
    // 构建配置映射表
    configList?.forEach(config => {
      this.serverConfigMap.set(config.placeholder, config.replaceText)
    })

    // 重新处理所有消息
    this.processAllMessages()
  }

  /**
   * 处理单条消息中的占位符
   */
  private processMessage(message: string): string {
    if (typeof message !== 'string') {
      return message;
    }

    let processedMessage = message
    for (const [placeholder, replacement] of this.serverConfigMap.entries()) {
      processedMessage = processedMessage.replace(
        new RegExp(placeholder.replace(/[{}]/g, '\\$&'), 'g'),
        replacement
      )
    }
    return processedMessage
  }

  /**
   * 处理所有消息
   */
  private processAllMessages(): void {
    const processObject = (obj: Record<string, any>, target: Record<string, any>) => {
      for (const key in obj) {
        if (typeof obj[key] === 'string') {
          target[key] = this.processMessage(obj[key])
        } else if (typeof obj[key] === 'object' && obj[key] !== null) {
          target[key] = {}
          processObject(obj[key], target[key])
        } else {
          target[key] = obj[key]
        }
      }
    }

    this.processedMessages = {}
    processObject(this.baseLocalText, this.processedMessages)
  }

  /**
   * 根据键路径获取消息
   */
  getMessageByKey(messages: Record<string, any>, key: string): any {
    const keys = key.split('.')
    let result = messages

    for (const k of keys) {
      if (!result || typeof result !== 'object') {
        return undefined
      }
      result = result[k]
    }

    return result
  }
}

// 导出单例实例
export const dynamicI18nHandler = new DynamicI18nHandler()
